import welfareApi from '../apis/welfare'

const state = {
  myProfile: {

  },
  awardInfo: {

  },
  flowerRecords: {
    data: [],
    total: 0,
    currentPage: 0,
    lastPage: 1,
    loading: false
  },
  participants: {
    data: [],
    total: 0,
    currentPage: 0,
    lastPage: 1,
    loading: false
  },
  search: {
    keyword: '',
    sort: 'random',
    randomSeed: new Date().getTime()
  },
  topParticipants: [],
  myFlowerParticipants: []
}

const mutations = {
  setWelfareAwardInfo (state, data) {
    state.awardInfo = data
  },
  setMyWelfareProfile (state, data) {
    state.myProfile = data
  },
  setFlowerRecordsLoading (state, { loading }) {
    state.flowerRecords.loading = loading
  },
  setFlowerRecords (state, data) {
    state.flowerRecords = {
      ...state.flowerRecords,
      currentPage: data.current_page,
      lastPage: data.last_page,
      data: data.current_page === 1 ? data.data : [...state.flowerRecords.data, ...data.data],
      total: data.total,
      loading: false
    }
  },
  setWelfareParticipantsLoading (state, { loading }) {
    state.participants.loading = loading
  },
  setWelfareParticipants (state, data) {
    state.participants = {
      ...state.participants,
      currentPage: data.current_page,
      lastPage: data.last_page,
      data: data.current_page === 1 ? data.data : [...state.participants.data, ...data.data],
      total: data.total,
      loading: false
    }
  },
  updateMyProfile (state, { count }) {
    state.myProfile.remain_flower_count -= count
    state.myProfile.send_flower_count += count
  },
  updateParticipant (state, { participantId, count }) {
    for (let item of state.participants.data) {
      if (item.id === participantId) {
        item.flower_count += count
        break
      }
    }
  },
  setParticipantSearch (state, search) {
    state.search = {
      ...state.search,
      ...search
    }
  },
  setTopParticipants (state, data) {
    state.topParticipants = data.data
  },
  setReminder (state, reminder) {
    state.myProfile.reminder = reminder
  },
  setMyFlowerParticipants (state, data) {
    state.myFlowerParticipants = data
  },
  addReminFlowerCount (state, count) {
    state.myProfile.remain_flower_count += count
    state.myProfile.get_flower_count += count
  }
}

const actions = {
  getWelfareAwardInfo ({ commit }, year) {
    return welfareApi.getWelfareAwardInfo(year)
      .then((res) => {
        commit('setWelfareAwardInfo', res.data)
        return res
      })
  },
  getMyWelfareProfile ({ commit }, year) {
    return welfareApi.getMyProfile(year)
      .then((res) => {
        commit('setMyWelfareProfile', res.data)
        return res
      })
  },
  signInWelfare ({ commit }, year) {
    return welfareApi.signIn(year)
      .then((res) => {
        commit('setMyWelfareProfile', res.data)
        return res
      })
  },
  answerQuestion ({ commit }, { questionId, answer }) {
    return welfareApi.answerQuestion(questionId, answer)
      .then((res) => {
        if (res.data && answer === res.data.answer) {
          commit('addReminFlowerCount', 3)
        }
        return res
      })
  },
  getFlowerRecords ({ commit }, { year, page, perPage = 15 }) {
    commit('setFlowerRecordsLoading', { loading: true })
    return welfareApi.getFlowerRecords(year, page, perPage)
      .then((res) => {
        commit('setFlowerRecords', res.data)
        return res
      })
      .catch((err) => {
        commit('setFlowerRecordsLoading', { loading: false })
        console.log(err)
      })
  },
  getWelfareParticipants ({ commit }, { year, page, perPage = 20, sort, randomSeed }) {
    commit('setWelfareParticipantsLoading', { loading: true })
    return welfareApi.getWelfareParticipants(year, sort, page, randomSeed, perPage)
      .then((res) => {
        commit('setWelfareParticipants', res.data)
        return res
      })
      .catch((err) => {
        commit('setWelfareParticipantsLoading', { loading: false })
        console.log(err)
      })
  },
  shareWelfareAward ({ commit }, { year }) {
    return welfareApi.share(year)
      .then((res) => {
        commit('setMyWelfareProfile', res.data)
        return res
      })
  },
  sendWelfareFlower ({ commit }, { participantId, count }) {
    return welfareApi.sendFlower(participantId, count)
      .then((res) => {
        commit('updateMyProfile', { count })
        commit('updateParticipant', { participantId, count })
        return res
      })
  },
  getTopParticipants ({ commit }, { year }) {
    return welfareApi.getTopParticipants(year)
      .then((res) => {
        commit('setTopParticipants', res.data)
        return res
      })
      .catch((err) => {
        console.log(err)
      })
  },
  switchReminder ({ commit }, { year, reminder }) {
    return welfareApi.switchReminder(year, reminder)
      .then((res) => {
        commit('setMyWelfareProfile', res.data)
        return res
      })
  },
  getMyFlowerParticipants ({ commit }, { year }) {
    return welfareApi.getMyFlowerParticipants(year)
      .then((res) => {
        commit('setMyFlowerParticipants', res.data)
      })
  }
}

export default {
  state,
  mutations,
  actions
}
